




































import { computed, defineComponent, PropType, ref, watch } from "@vue/composition-api";
import { TagInfoType } from "@scrile/api-provider/dist/api/TagsProvider";
import { InputUserPublicDataSearch, UserLocation } from "@scrile/api-provider/dist/api/UserPublicDataProvider";
import config from "@/config";
import BaseIcon from "@/components/BaseIcon";
import BaseInput from "@/components/BaseInput";
import FiltersCreatorModal from "../CreatorsFiltersModal";

export default defineComponent({
  name: "CreatorsFilters",
  components: {
    FiltersCreatorModal,
    BaseIcon,
    BaseInput,
  },
  props: {
    value: { type: Object as PropType<Partial<InputUserPublicDataSearch>>, require: true },
  },
  setup(_, { emit }) {
    const showFiltersCreatorModal = ref(false);
    const allowFilters = computed(() => config.featureTags || !config.featureHideLocalization);
    const relevantTerm = ref("");
    const languages = ref<string[]>([]);
    const locations = ref<UserLocation[]>([]);
    const tagsIds = ref<string[]>([]);

    const onInputSearch = (value: string = "") => {
      relevantTerm.value = value;
    };

    const selectTags = (value: string[]) => {
      showFiltersCreatorModal.value = false;
      tagsIds.value = value;
    };

    const selectLanguages = (value: string[]) => {
      showFiltersCreatorModal.value = false;
      languages.value = value;
    };

    const selectLocations = (value: UserLocation[]) => {
      showFiltersCreatorModal.value = false;
      locations.value = value;
    };

    watch([relevantTerm, tagsIds, languages, locations], () => {
      emit("input", { relevantTerm, tags: tagsIds, languages, locations });
    });

    return {
      allowFilters,
      relevantTerm,
      showFiltersCreatorModal,
      TagInfoType,
      tagsIds,
      languages,
      locations,
      selectTags,
      onInputSearch,
      selectLanguages,
      selectLocations,
    };
  },
});
